<button [disabled]="loading" nzSize="small" nz-button nzType="primary" type="submit" [attr.form]="formId">
    <span nz-icon nzType="send"></span>
    <span>Envoyer</span>
</button>